const MS_PER_DAY = 86_400_000;
function addDays(date, days) {
    const d = new Date(date);
    d.setUTCDate(d.getUTCDate() + days);
    return d;
}
export function durationToDays(duration) {
    const d = duration.trim().toLowerCase();
    if (d === '1 day')
        return 1;
    if (d === '3 days')
        return 3;
    if (d === '1 week')
        return 7;
    if (d === '2 weeks')
        return 14;
    if (d === '1 month')
        return 30;
    if (d === '6 weeks')
        return 42;
    if (d === '2 months')
        return 60;
    if (d === 'until project end')
        return null;
    const mDays = d.match(/^(\d+)\s*days?$/);
    if (mDays)
        return parseInt(mDays[1], 10);
    const mWeeks = d.match(/^(\d+)\s*weeks?$/);
    if (mWeeks)
        return parseInt(mWeeks[1], 10) * 7;
    const mMonths = d.match(/^(\d+)\s*months?$/);
    if (mMonths)
        return parseInt(mMonths[1], 10) * 30;
    return null;
}
export function computeEndDate(startDate, duration, projectEndDate) {
    if (duration.trim().toLowerCase() === 'until project end') {
        return projectEndDate ?? null;
    }
    const days = durationToDays(duration);
    if (days === null)
        return null;
    const start = new Date(startDate);
    if (Number.isNaN(start.getTime()))
        return null;
    const end = addDays(start, days - 1);
    return end.toISOString().slice(0, 10);
}
export function daysBetween(startIso, endIso) {
    const a = new Date(startIso).getTime();
    const b = new Date(endIso).getTime();
    return Math.round((b - a) / MS_PER_DAY);
}
//# sourceMappingURL=duration.js.map